export default __webpack_public_path__ + "static/media/2122 spice rack side.05f97b4a.png";